<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="approval && approval.equipment.name">
      Deseja realmente rejeitar o equipamento {{ approval.equipment.name }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      class="field-dialog__content__scroll p-24"
      fxLayout="column"
      name="form"
      [formGroup]="rejectForm"
      fusePerfectScrollbar
    >
      <p>
        Caso deseje continuar com a <b>rejeição</b> do equipamento, a empresa <b>{{ approval.company.name }}</b> que
        cadastrou o equipamento será notificado por e-mail e deverá fazer as ações/ajustes solicitados.
      </p>
      <span>Dados do equipamento:</span>
      <ul>
        <li>Número de série: {{ approval.equipment.number }}</li>
        <li>Nome do modelo: {{ approval.equipment.name }}</li>
        <li>Tipo de equipamento: {{ approval.equipment.type.name }}</li>
        <li>
          Endereço:
          <ul>
            <li>Localização: {{ approval.equipment.location.name }}</li>
            <li>Setor: {{ approval.equipment.locationSector?.name }}</li>
            <li>Ambiente: {{ approval.equipment.locationEnvironment?.name }}</li>
            <li>Endereço completo: {{ approval.equipment.location.address.formattedAddress }}</li>
          </ul>
        </li>
      </ul>
      <span>Utilize o campo abaixo para deixar uma observação a empresa para que ela tome uma ação.</span>
      <mat-form-field appearance="legacy" class="w-100-p pt-18">
        <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NOTE' | translate }}</mat-label>
        <textarea
          required
          matInput
          matTextareaAutosize
          matAutosizeMinRows="2"
          matAutosizeMaxRows="5"
          formControlName="message"
          autofocus
        ></textarea>
      </mat-form-field>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <button
        class="field-background mr-16"
        mat-raised-button
        [disabled]="!this.rejectForm.valid"
        (click)="rejectApproval()"
      >
        <span fxHide.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.WANT_TO_REJECT_EQUIPMENT' | translate }}
        </span>
        <span fxShow="false" fxShow.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.REJECT' | translate }}
        </span>
      </button>

      <button class="grey-400" mat-raised-button (click)="matDialogRef.close()">
        <span fxHide.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.THINK_SO' | translate }}
        </span>
        <span fxShow="false" fxShow.xs>
          {{ 'APPROVALS_EQUIPMENTS.DIALOG.CANCEL' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
